import { AgxColumn, AgxRow, AgxTypography } from '@urbanx/agx.ui-components2'
import { useMemo } from 'react'

interface PoisonQueueInformationTidbitProps {
  label: string
  value?: string | number | string[]
}

const PoisonQueueInformationTidbit = ({
  label,
  value,
}: PoisonQueueInformationTidbitProps) => {
  const isArray = useMemo(() => Array.isArray(value), [value])

  if (isArray) {
    return (
      <AgxColumn gap="spacing-md">
        <AgxTypography
          id={`poison-queue-information-tidbit-${label.toLowerCase()}`}
          type={'label'}
          size={'small'}
        >
          {label}
        </AgxTypography>

        {(value as Array<string>).map((val, idx) => (
          <AgxTypography
            id={`poison-queue-information-tidbit-${label.toLowerCase()}-value-${idx}`}
            key={idx}
            type={'body'}
            size={'small'}
            style={{
              marginLeft: '16px',
            }}
          >
            {val ?? '-'}
          </AgxTypography>
        ))}
      </AgxColumn>
    )
  }

  return (
    <AgxRow gap="spacing-lg" alignItems="alignCenter">
      <AgxTypography
        id={`poison-queue-information-tidbit-${label.toLowerCase()}`}
        type={'label'}
        size={'small'}
      >
        {label}:
      </AgxTypography>

      <AgxTypography
        id={`poison-queue-information-tidbit-${label.toLowerCase()}-value`}
        type={'body'}
        size={'small'}
      >
        {value ?? '-'}
      </AgxTypography>
    </AgxRow>
  )
}

export default PoisonQueueInformationTidbit
